import { Action } from '@ngrx/store';
import { Deal } from '../../types/deal.types';

export enum BidsActionTypes {
  LoadBids = '[Bids] Load',
  LoadBidsSuccess = '[Bids] Load Success',
  LoadBidsFail = '[Bids] Load Fail',
  CompareBidsModeChange = '[Bids Compare] Mode Change',
  CompareBidsListChange = '[Bids Compare] List Change',
  CompareBidsColumnChange = '[Bids Compare] Column Change',
  CompareBidsReset = '[Bids Compare] Reset'
}

export class LoadBids implements Action {
  public readonly type = BidsActionTypes.LoadBids;

  constructor(public readonly payload: string) {}
}

export class LoadBidsSuccess implements Action {
  public readonly type = BidsActionTypes.LoadBidsSuccess;

  constructor(public payload: { data: Deal[] }) {}
}

export class LoadBidsFail implements Action {
  public readonly type = BidsActionTypes.LoadBidsFail;

  constructor(public payload: string) {}
}

export class CompareBidsModeChange implements Action {
  public readonly type = BidsActionTypes.CompareBidsModeChange;
}

export class CompareBidsListChange implements Action {
  public readonly type = BidsActionTypes.CompareBidsListChange;

  constructor(public payload: number) {}
}

export class CompareBidsColumnChange implements Action {
  public readonly type = BidsActionTypes.CompareBidsColumnChange;

  constructor(public payload: string) {}
}

export class CompareBidsReset implements Action {
  public readonly type = BidsActionTypes.CompareBidsReset;
}

export type BidsActionUnion =
  | LoadBids
  | LoadBidsSuccess
  | LoadBidsFail
  | CompareBidsModeChange
  | CompareBidsListChange
  | CompareBidsColumnChange
  | CompareBidsReset;
